<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';
  import type { SelectionParams } from './datatable.types';

  export let itemsSelection: boolean;
  export let selectionParams: SelectionParams | undefined;
  export let showSelectionCount: boolean;

  let eventHandler = new EventHandler();

  function emitEvent(name: string, detail?: CustomEvent['detail']) {
    eventHandler.dispatch(name, detail || {});
  }
</script>

<div class="mc-datatable__topbar-selection">
  {#if itemsSelection && showSelectionCount && selectionParams != null && (selectionParams?.idsSelected.length || selectionParams?.allSelected)}
    <div class="center-selection-label">
      {#if selectionParams?.allSelected}
        {#if selectionParams?.excludedIdsFromSelection.length > 0}
          <span
            ><b
              >{selectionParams?.totalItems -
                selectionParams?.excludedIdsFromSelection.length}
              {selectionParams?.selectedLabel || 'selected'}</b
            >
            {selectionParams?.rowsOnPageLabel || 'rows on the page. '}-
            <a href="/" on:click|preventDefault={() => emitEvent('select-all')}
              >{selectionParams?.selectAllLabel || 'Select all'}
              {selectionParams?.totalItems}
              {selectionParams?.rowsOfTableLabel || 'rows of the table'}</a
            >
          </span>
        {:else}
          <span
            >{selectionParams?.rowsSelectedLabel ||
              'All rows are selected in the table.'} -
            <a
              href="/"
              on:click|preventDefault={() => emitEvent('clear-selection')}
              >{selectionParams?.clearSelectionLabel || 'Clear selection'}</a
            >
          </span>
        {/if}
      {:else}
        <span
          ><b
            >{selectionParams?.idsSelected.length}
            {selectionParams?.selectedLabel || 'selected'}</b
          >
          {#if selectionParams?.idsSelected && selectionParams?.idsSelected.length > 0}
            {selectionParams?.rowsOnPageLabel || 'rows on the page. '}-
            <a href="/" on:click|preventDefault={() => emitEvent('select-all')}
              >{selectionParams?.selectAllLabel || 'Select all'}
              {selectionParams?.totalItems}
              {selectionParams?.rowsOfTableLabel || 'rows of the table'}</a
            >
          {/if}
        </span>
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  .mc-datatable__topbar-selection {
    width: 100%;
    background-color: white;
    border-radius: 4px;
  }

  .center-selection-label {
    text-align: center;
  }

  .center-selection-label span {
    line-height: 2;
  }
</style>
